import axios from 'axios';

const API = 'https://carriera-backend.onrender.com/api';

// CVs live in a private storage bucket; the backend hands out a link that works
// for 5 minutes (GET /api/candidates/:id/cv-link), so we ask for a fresh one on
// every click. The tab is opened before the request because browsers block
// pop-ups that open after a wait.
export default function openCv(candidateId, headers) {
  return openLink(`/candidates/${candidateId}/cv-link`, headers, 'Could not open the CV.');
}

// Any route answering { url } with a short-lived link (also Kate's profile drafts).
export async function openLink(path, headers, failMessage) {
  const tab = window.open('', '_blank');
  if (tab) tab.opener = null;
  try {
    const { data } = await axios.get(`${API}${path}`, { headers });
    if (tab) tab.location.href = data.url;
    else window.location.href = data.url;
  } catch (err) {
    if (tab) tab.close();
    alert(err.response?.data?.error || failMessage);
  }
}
